import { apiPost } from '../api';
import { ApiNames, ApiPath } from '../enums';

import { UploadPolicyDTO } from './model';

/**
 * Creates a signed POST policy for the browser file upload. Expires in one hour by default.
 * @see https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
 */
export async function getUploadPolicy(token: string): Promise<UploadPolicyDTO> {
  return apiPost<UploadPolicyDTO, { token: string }>(
    ApiNames.MonorepoApiEndpoint,
    ApiPath.GetUploadPolicy,
    { token },
    false
  );
}
